export enum Theme {
  fly = 'fly',
  drive = 'drive',
  multiFly = 'multi-fly',
  multiDrive = 'multi-drive',
  solo = 'solo',
  totm = 'totm',
  incontrol = 'in-control',
  bucketList = 'bucket-list',
  escapeTour = 'escape-tour',
  broke = 'broke',
  train = 'train',
  zonvoordeel = 'lente-in-je-bol',
  newplaces = 'new-places',
  summerHoliday = 'summer-holiday',
  lastMinute = 'last-minute',
  foodLoversDrive = 'food-lovers-drive',
  foodLoversFly = 'food-lovers-fly',
  themeOfTheMonth = 'theme-of-the-month',
}

export enum ThemeTypes {
  fly = 'fly',
  road = 'road',
  train = 'train',
}

export const flyThemes: Theme[] = [
  Theme.fly,
  Theme.multiFly,
  Theme.incontrol,
  Theme.bucketList,
  Theme.escapeTour,
  Theme.zonvoordeel,
  Theme.newplaces,
  Theme.summerHoliday,
  Theme.lastMinute,
  Theme.broke,
  Theme.foodLoversFly,
  Theme.themeOfTheMonth,
]

export const driveThemes: Theme[] = [
  Theme.drive,
  Theme.multiDrive,
  Theme.train,
  Theme.foodLoversDrive,
]

export function getThemeAPIName(theme: Theme) {
  switch (theme) {
    case Theme.multiFly:
      return 'multi-city'
    case Theme.multiDrive:
      return 'drive'
    case Theme.solo:
      return 'solo-together'
    default:
      return theme.toString()
  }
}

export function getThemeId(theme: Theme) {
  switch (theme) {
    case Theme.fly:
    default:
      return 50
    case Theme.drive:
      return 20
    case Theme.multiFly:
      return 1
    case Theme.multiDrive:
      return 20
    case Theme.solo:
      return 18
    case Theme.totm:
      return 38
    case Theme.incontrol:
      return 52
    case Theme.broke:
      return 53
    case Theme.zonvoordeel:
      return 55
    case Theme.train:
      return 61
    case Theme.bucketList:
      return 63
    case Theme.escapeTour:
      return 64
    case Theme.foodLoversDrive:
      return 65
    case Theme.themeOfTheMonth:
      return 66
  }
}
